import React from 'react';
import type { RiskLevel } from '../../../types/kyb.types';

interface RiskBadgeProps {
  level: RiskLevel;
  score: number;
  size?: 'sm' | 'md' | 'lg';
  showScore?: boolean;
}

export const RiskBadge: React.FC<RiskBadgeProps> = ({ 
  level, 
  score, 
  size = 'md', 
  showScore = false 
}) => {
  const styles: Record<RiskLevel, string> = {
    CRITICAL: 'bg-red-600 text-white',
    HIGH: 'bg-orange-500 text-white',
    MEDIUM: 'bg-yellow-500 text-white',
    LOW: 'bg-blue-500 text-white',
    MINIMAL: 'bg-green-500 text-white'
  };

  const sizeStyles = {
    sm: 'px-3 py-1 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg'
  };

  return (
    <div className={`${styles[level]} ${sizeStyles[size]} font-bold rounded-lg inline-block shadow-lg`}>
      {level} {showScore && `(${score}/100)`}
    </div>
  );
};